import { Action } from 'redux'
import { isType } from 'typescript-fsa'
import { showNotificationArea, hideNotificationArea, setNotificationCount } from './actions'
import { LOCATION_CHANGE } from 'connected-react-router'
import { openSubmenu } from '../actions'
import { ApplicationState } from '../../../../reducers'
import { getNotifications } from '../../../../utilities'
import { Notification } from '../../../../models/notification'

export type State = {
    notificationAreaShown: boolean
    notificationCount: number
}

export const initialState: State = {
    notificationAreaShown: false,
    notificationCount: notificationListSelector().length,
}

export function notificationReducer(state: State = initialState, action: Action): State {
    if (isType(action, showNotificationArea)) {
        return {
            ...state,
            notificationAreaShown: true,
        }
    }

    if (isType(action, hideNotificationArea)) {
        return {
            ...state,
            notificationAreaShown: false,
        }
    }

    if (isType(action, openSubmenu)) {
        return {
            ...state,
            notificationAreaShown: false,
        }
    }

    if (isType(action, setNotificationCount)) {
        return {
            ...state,
            notificationCount: action.payload,
        }
    }

    if (action.type === LOCATION_CHANGE) {
        return {
            ...state,
            notificationAreaShown: false,
        }
    }

    return state
}

export function isNotificationAreaShownSelector(state: ApplicationState) {
    return state.notifications.notificationAreaShown
}

export function notificationCountSelector(state: ApplicationState) {
    return state.notifications.notificationCount
}

// It's a bit dodgy to have a selector like this, which quietly reads from
// local storage. It works in this situation because we know the redux store
// has changed when you click on the notification bell, so know this function
// will get called then. However as it is, this selector is not safe to use
// as a normal selector.
//
// The way to fix this would be to trigger a rerender when the relevant parts
// of local storage change, but in the current state of our application, that
// would seem to add an extra, unnecessary page render.
export function notificationListSelector(state?: ApplicationState) {
    const group = getNotifications()

    return Object.keys(group).reduce(
        (prev, key) => {
            return [
                ...prev,
                group[key],
            ]
        },
        [] as Notification[]
    )
}

export function sortedNotificationListSelector(state?: ApplicationState) {
    return notificationListSelector(state).sort((a, b) => b.sent - a.sent)
}
